import React from 'react'
import '../Console.css'

export default class Console extends React.Component {
    state = {
        console_initial_txt: "pratik$ ",
        output_txt: "",
        console_txt: "",
        help_txt: "\n> Hep Menu\n\
        help: lists all available commands\n\
        about: displays details about me\n\
        social: displays social handles [-i instagram, -t twitter, -g GitHub, -w website, -l linkedin]\n\
        Usage of Social: social [option]\n\
        exit: To exit Console\n\
        ",
        about_txt: "\n> I'm a front-end developer.\n",
        social: {
            instagram: "\nInstagram: @pratikktiwari\n",
            twitter: "\nTwitter: @pratikktiwari\n",
            linkedin: "\LinkedIn: https://linkedin.com/in/pratikktiwari\n",
            github: "\GitHub: https://github.com/pratikktiwari\n",
            website: "\Website: https://pratiktiwari.com\n",
        },
        intervalId: null,
        question: "Hello world!!!"

    }
    componentDidMount() {
        let intervalId = setInterval(this.scrollListener, 1000);
        this.setState({ intervalId: intervalId })
    }
    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }
    onChange = (e) => {
        this.setState({ console_txt: e.target.value })
    }
    scrollListener = () => {
        var elem = document.getElementById('console_results_div');
        elem.scrollTop = elem.scrollHeight;

    }
    // setInterval(updateScroll,1000);
    onKeyDown = (e) => {
        if (e.keyCode === 13) {
            const { console_txt, output_txt } = this.state
            switch (console_txt) {
                case "help":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.help_txt,
                        console_txt: ""
                    })
                    break
                case "-h":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.help_txt,
                        console_txt: ""
                    })
                    break
                case "about":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.about_txt,
                        console_txt: ""
                    })
                    break
                case "social -i":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.social.instagram,
                        console_txt: ""
                    })
                    break
                case "social -t":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.social.twitter,
                        console_txt: ""
                    })
                    break
                case "social -w":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.social.website,
                        console_txt: ""
                    })
                    break
                case "social -l":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.social.linkedin,
                        console_txt: ""
                    })
                    break
                case "social -g":
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + this.state.social.github,
                        console_txt: ""
                    })
                    break
                case "clear":
                    e.preventDefault()
                    this.setState({
                        output_txt: "",
                        console_txt: ""
                    })
                    break
                case "exit":
                    e.preventDefault()
                    this.setState({
                        output_txt: "",
                        console_txt: ""
                    })
                    this.props.onClickConsole()
                    clearInterval(this.state.intervalId)
                    break
                default:
                    e.preventDefault()
                    this.setState({
                        output_txt: output_txt + "\n> Enter valid command. For help use [-h] or [help]\n",
                        console_txt: ""
                    })
            }
        }
    }

    render() {
        const { console_txt, console_initial_txt, output_txt } = this.state

        return (
            <div className="console_main_container" id="console_main_container">

                <div className="console_results_div" id="console_results_div">
                    <div className="console_banner">
                        <pre style={{ textAlign: "left", }}>
                            , _                        ,  ,<br />
                            /|/ \ ,_   _, _|_ o |)     /|_/<br />
                            |__//  | / |  |  | |/)     |\<br />
                            |____  |/\/|_/|_/|/| \/    | \_/o<br />
                            () |o          _,   ,_  o<br />
                            || |  |  |_/ |  /  | |<br />
                            (/ |/ \/ \/  \/|_/   |/|/<br />

                        </pre>

                    </div>
                    <div>
                        <h5 style={{ textAlign: 'center' }}>Type help for list of available commands</h5>
                    </div>
                    <div className="main_output_result_code">
                        <pre>{output_txt}</pre>
                    </div>
                </div>
                <div className="bottom_most_div_txt_div">
                    <div>{console_initial_txt}</div>
                    <textarea rows={2} spellCheck={false} value={console_txt} onKeyDown={this.onKeyDown} onChange={this.onChange}></textarea>
                </div>
            </div>
        )
    }
}